module.exports = __webpack_public_path__ + "media/images/avatars/user_avatar_portrait-fdf98d98060e39e31d907f3937f8e46e.png";